<template>
    <div style="width: 100wh; height: 50vh; padding-left: 20%; padding-top: 5%;">
      <video
        ref="videoPlayer"
        width="1000"
        height="320"
        controls
        @play="onPlay"
        @pause="onPause"
        @ended="onEnded"
      >
        <source :src="url" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </template>
  
  <script>
  export default {
    data(){
        return{
            url:''

        }
    },
    created(){
        let url = this.$route.query.url
        this.url = url
    },
    methods: {
      playVideo() {
        this.$refs.videoPlayer.play();
      },
      pauseVideo() {
        this.$refs.videoPlayer.pause();
      },
      onPlay() {
        console.log('Video is playing');
      },
      onPause() {
        console.log('Video is paused');
      },
      onEnded() {
        console.log('Video has ended');
      }
    }
  };
  </script>
  
  <style>
  /* 添加你的样式 */
  </style>
  